import { useCallback, useMemo } from 'react'

import { useTrackIsElementVisible } from '@src/quince-site-common/src/hooks/useTrackIsElementVisible'
import { getSanitizedHtml } from '@src/quince-site-common/src/utils/getSanitizedHtml'

import { offerMessageDsClass } from './product-offer-message-ds.styles'
import { getTrackerAddedComboMessageOffer } from './utils'

import type { ProductOfferMessageProps } from './product-offer-message.types'

// DS twin of legacy `ProductOfferMessage` — identical logic + telemetry, legacy SCSS box swapped for
// the Panda `offerMessageDsClass` (V2-unconditional, the only shipped design).
export const ProductOfferMessageDS = (props: ProductOfferMessageProps) => {
  const { productId, offerMessageFromPC } = props
  const getIsVisibleTrackParams = useCallback(
    () => ({
      action: 'pdp_offer_message',
      value: true,
      context: {
        productId,
      },
    }),
    [productId],
  )
  const { ref: trackIsVisibleRef } = useTrackIsElementVisible(getIsVisibleTrackParams)

  const offerMessageWithTracker = useMemo(
    () =>
      offerMessageFromPC && productId !== undefined
        ? getTrackerAddedComboMessageOffer(offerMessageFromPC, productId)
        : offerMessageFromPC,
    [offerMessageFromPC, productId],
  )

  return (
    <>
      {!props.hideOfferMessage && offerMessageWithTracker && (
        <div className={offerMessageDsClass} ref={trackIsVisibleRef}>
          <div
            // eslint-disable-next-line react/no-danger
            dangerouslySetInnerHTML={{
              __html: getSanitizedHtml(offerMessageWithTracker),
            }}
          ></div>
        </div>
      )}
    </>
  )
}
